module.exports = __webpack_public_path__ + "static/media/WxGrapher-thumbnail.47925052.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ToolCard/thumbnails/WxGrapher-thumbnail.png
// module id = 1224
// module chunks = 0